import { v4 as uuidv4 } from 'uuid';

import { reportUsageV2 } from '../../../api/usageV2';
import { getProtobufSearchScope } from '../getProtobufSearchScope';
import { getTimeFromSearchConversationStart } from '../getTimeFromSearchConversationStart';
import { loadProtobuf } from '../lazyExports';

import { ThreadSearchSubmittedProps } from './searchEvents.types';

const packageName = 'events';
const eventName = 'ThreadSearchSubmittedV1';
const emptyId = 'ERROR - no-conversation-id';

const getSearchDate = (timestamp?: number) => {
  if (!timestamp) {
    return undefined;
  }

  const date = new Date(timestamp);

  return {
    year: date.getFullYear(),
    month: date.getMonth(),
    day: date.getDay(),
  };
};

type ReportThreadSearchSubmitted = (props: ThreadSearchSubmittedProps) => void;
export const reportThreadSearchSubmitted: ReportThreadSearchSubmitted = async ({
  conversationId,
  logicalId,
  resultType,
  queryLength,
  wordCount,
  conversationStart,
  filters = {},
}) => {
  const { events } = await loadProtobuf();
  const { groupTelemetryId, dateFilterStartTimestamp, dateFilterEndTimestamp } = filters;
  const groupId = groupTelemetryId ? parseInt(groupTelemetryId) : undefined;

  const reportableScope = await getProtobufSearchScope(resultType, groupTelemetryId);
  const startDate = getSearchDate(dateFilterStartTimestamp);
  const endDate = getSearchDate(dateFilterEndTimestamp);
  const timeToActionMilliseconds = getTimeFromSearchConversationStart(conversationStart);

  const threadSearchSubmittedProps = {
    conversationId: conversationId ?? emptyId,
    logicalId: logicalId ?? uuidv4(),
    length: queryLength,
    wordCount,
    timeToActionMilliseconds,
    groupId,
    scope: reportableScope,
    startDate,
    endDate,
  };

  const threadSearchViewThreadClicked = events.ThreadSearchSubmittedV1.encode(threadSearchSubmittedProps).finish();

  reportUsageV2({
    packageName,
    eventName,
    value: threadSearchViewThreadClicked,
  });
};
